<template>
  <div id="app">
    <Header routeValue="2" ref="header"></Header>
    <content class="content">
      <div class="terms_box">
        <div class="title">Terms & Conditions</div>
        <div class="time">Last modified: August 2024</div>
        <div class="row_view" style="font-family: IBM Plex Sans;">
          <p class="mb-6">This agreement is jointly established between the users
            (hereinafter referred to as
            "<strong><i>you</i></strong> ") of
            <strong><i>Printbelle</i></strong> platform (including PC website, mobile website, and APP, hereinafter
            referred to as
            ("<strong><i>Platform</i></strong> ") and the operator of Printbelle platform "DIKE INTERNATIONAL CO.,
            LIMITED"
            (hereinafter referred to as
            "<strong><i>DIKE</i></strong> " or "<strong><i>we</i></strong> ") regarding the related matters of
            Printbelle
            platform services. THIS AGREEMENT HAS THE EFFECT OF A CONTRACT, AND PLEASE READ IT CAREFULLY WHEN
            REGISTERING AS A USER.
          </p>
          <p class="mb-6" style="margin:16px 0">1.Confirmation and Acceptance of the Agreement</p>
          <p class="mb-6" style="width: 878px">1.1 THE HEADINGS OF EACH CLAUSE ARE FOR THE PURPOSE OF HELPING YOU
            UNDERSTAND THE MAIN CONTENT
            OF THE CLAUSE, AND DO NOT AFFECT OR LIMIT THE MEANING OR INTERPRETATION OF THE TERMS OF THIS AGREEMENT. TO
            PROTECT YOUR OWN RIGHTS AND INTERESTS, IT IS RECOMMENDED THAT YOU CAREFULLY READ THE SPECIFIC EXPRESSION OF
            EACH CLAUSE.</p>
          <p class="mb-6" style="width: 905px">
            1.2 BEFORE CLICKING "<strong><i>AGREE</i></strong> " TO THIS AGREEMENT DURING THE REGISTRATION PROCESS, YOU
            SHOULD
            CAREFULLY READ
            THIS AGREEMENT. PLEASE READ AND FULLY UNDERSTAND THE CONTENTS OF EACH CLAUSE, ESPECIALLY THE CLAUSES THAT
            EXEMPT OR LIMIT LIABILITY, THE CLAUSES ON APPLICABLE LAWS AND DISPUTE RESOLUTION. CLAUSES IN BOLD SHOULD BE
            GIVEN SPECIAL ATTENTION. IF YOU HAVE ANY QUESTIONS ABOUT THE AGREEMENT, YOU CAN CONSULT THE PLATFORM'S
            CUSTOMER SERVICE.
          </p>
          <p class="mb-6" style="width: 906px">
            1.3 WHEN YOU FILL IN THE INFORMATION AS PROMPTED ON THE REGISTRATION PAGE, READ AND AGREE TO THIS AGREEMENT,
            AND COMPLETE ALL REGISTRATION PROCEDURES, IT INDICATES THAT YOU HAVE FULLY READ, UNDERSTOOD, AND ACCEPTED
            ALL THE CONTENTS OF THIS AGREEMENT, AND REACHED AN AGREEMENT WITH US, BECOMING A
            "<strong><i>USER</i></strong> "
            OF OUR PLATFORM. IF YOU DO NOT AGREE TO THIS AGREEMENT OR ANY OF ITS TERMS DURING THE READING PROCESS, YOU
            SHOULD IMMEDIATELY STOP THE REGISTRATION PROCESS.
          </p>
          <p class="mb-6" style="width: 906px">
            <strong>1.4 IF YOU HAVE NOT APPLIED FOR THE REGISTRATION PROCESS, OR HAVE ALREADY BECOME A REGISTERED USER
              OF OUR PLATFORM BEFORE THIS AGREEMENT TAKES EFFECT, YOUR ACCESS AND/OR USE OF OUR PLATFORM WEBSITE WILL BE
              DEEMED AS YOUR AGREEMENT TO ACCEPT ALL THE CONTENTS OF THIS AGREEMENT. OTHERWISE, PLEASE DO NOT ACCESS OR
              USE OUR PLATFORM WEBSITE.</strong>
          </p>
          <p class="mb-6" style="margin:16px 0">2. Definitions</p>
          <p class="mb-6" style="width: 880px">
            2.1 Our platform: Refers to Printbelle website and related client applications.<br>
            2.2 Our/platform operator: Refers to DIKE INTERNATIONAL CO., LIMITED<br>
            2.3 Our platform service: Refers to various information technology services (hereinafter referred to as
            "<strong><i>services</i></strong> ") provided to you by us based on the Internet, including but not limited
            to PC
            website, mobile
            website, and APP.<br>
            2.4 Our platform rules: Refers to all agreements, rules, terms, product process instructions, announcements,
            and other contents that have been published or may be published in the future on all our platform websites.
          </p>
          <p class="mb-6" style="margin:16px 0">3. Agreement Scope</p>
          <p class="mb-6" style="width: 892px">
            3.1 Contracting Parties
          </p>
          <p class="mb-6" style="width: 892px">
            (1) This agreement is jointly established by you and the operator of our platform, and has contractual
            effect on both you and the operator of our platform.
          </p>
          <p class="mb-6" style="width: 892px">
            (2) Our platform operator refers to the legal entity that operates our platform. You can determine the
            contracting party that performs the contract with you based on the above-defined terms. The platform
            operator under this agreement may change due to business adjustments of our platform. The changed platform
            operator will jointly perform this agreement with you and provide services to you, and the change of the
            platform operator will not affect your rights under this agreement. The platform operator of our platform
            may also be added due to the provision of new services of our platform. If you use the newly added services
            of our platform, it is deemed that you agree that the newly added platform operator will jointly perform
            this agreement with you. In case of disputes, you can determine the contracting party and the opposing party
            of the disputes based on the specific service you use and the specific behavior object that affects your
            rights.
          </p>
          <p class="mb-6" style="margin:16px 0">3.2 Supplementary Agreements</p>
          <p class="mb-6" style="width: 892px">
            Due to the rapid development of the Internet industry, the terms and conditions listed in this agreement
            cannot fully cover all your rights and obligations with us. The related statements and policies published on
            our platform, our platform rules, and agreements are supplementary agreements of this agreement and are
            inseparable from this agreement and have the same legal effect. If you continue to use our platform
            services, it is deemed that you agree to the above supplementary agreements.
          </p>
          <p class="mb-6" style="margin:16px 0">3.3 Amendment of the Agreement</p>
          <p class="mb-6" style="width: 863px">
            (1) WE MAY MODIFY THIS AGREEMENT AND SUPPLEMENTARY AGREEMENTS FROM TIME TO TIME ACCORDING TO THE CHANGES IN
            NATIONAL LAWS AND REGULATIONS AND THE NEEDS OF OUR PLATFORM SERVICES. THE MODIFIED AGREEMENTS AND
            SUPPLEMENTARY AGREEMENTS (HEREINAFTER REFERRED TO AS "AMENDMENTS") WILL BE NOTIFIED TO
            YOU IN THE FORM OF
            WEBSITE ANNOUNCEMENTS, SHORT MESSAGES, EMAILS, ETC.
          </p>
          <p class="mb-6">
            (2) IF YOU DO NOT AGREE TO THE AMENDMENTS, YOU SHOULD STOP USING OUR PLATFORM SERVICES FROM THE EFFECTIVE
            DATE OF THE AMENDMENTS. IF YOU CONTINUE TO USE OUR PLATFORM SERVICES AFTER THE AMENDMENTS BECOME EFFECTIVE,
            IT IS DEEMED THAT YOU AGREE TO THE AMENDMENTS THAT HAVE ALREADY BECOME EFFECTIVE.
          </p>
          <p class="mb-6" style="margin:16px 0">4. Account Registration and Use</p>
          <p class="mb-6">
            4.1 User Qualifications
          </p>
          <p class="mb-6">
            (1) Natural persons who are over 18 years of age and have full civil rights and capacity to act. If you do
            not have the corresponding civil capacity to act, you and your guardian should bear all the consequences
            resulting from this in accordance with the legal provisions;
          </p>
          <p class="mb-6" style="width: 892px">
            (2) Persons without or with limited capacity to act should obtain the consent of their guardian. If you are
            a minor, please access and/or use our platform website under the consent and guidance of your guardian;
          </p>
          <p class="mb-6">
            (3) Institutions, enterprises and institutions, social organizations and other organizations established and
            legally existing in accordance with Chinese laws, regulations and administrative regulations.
          </p>
          <p class="mb-6">
            4.2 Account Instructions
          </p>
          <p class="mb-6" style="width: 910px">
            (1) After you fill in the information according to the registration page prompts, read and agree to this
            agreement and complete all registration procedures, you can obtain an account on our platform and become a
            user of our platform.
          </p>
          <p class="mb-6" style="width: 910px">
            (2) You have the right to use the account name, email address, mobile phone number (hereinafter referred to
            as "<strong>Account name</strong>") and password (the account name and password are collectively referred to
            as "account") that you have set or confirmed to log in to the platform.
          </p>
          <p class="mb-6" style="width: 885px">
            (3) As the user account is associated with user information, you can only transfer the account when there
            are legal stipulations, judicial rulings or with our consent and in accordance with the transfer process
            specified in our platform rules. Once your account is transferred, the rights and obligations under that
            account are also transferred. In addition, your account cannot be transferred in any way, otherwise you will
            bear all the responsibilities arising from this.
          </p>
          <p class="mb-6" style="width: 855px">
            (4) In order to enable you to better use various services provided by our platform, we recommend that you
            complete real-name authentication in accordance with our platform requirements and relevant legal
            provisions.
          </p>
          <p class="mb-6" style="width: 910px">
            (5) If your account has not been logged in for a long time, we have the right to carry out clearance such as
            cancellation. Your account will not be able to log in to any of our platforms, and corresponding services
            will also be terminated. Before we carry out clearance for such accounts, we will notify you by means
            including but not limited to website announcements, internal messages, and client push notifications.
          </p>
          <p class="mb-6">
            4.3 Registration Information Management
          </p>
          <p class="mb-6">
            (1) Real and Legitimate
          </p>
          <p class="mb-6" style="width: 910px">
            When using our platform services, you should provide your information accurately and completely according to
            the prompts on the platform page (including your name, email address, contact phone number, contact address,
            etc.), so that we can contact you when necessary. You understand and agree that you have an obligation to
            maintain the truthfulness and validity of the information you provide.
          </p>
          <p class="mb-6">
            The account name you set must not violate the management regulations of the national laws and regulations
            and our platform rules regarding account registration names. Otherwise, we have the right to temporarily
            suspend or cancel your account name and report to the competent authority.
          </p>
          <p class="mb-6">
            You understand and promise that your account name, avatar, and profile and other registration information
            must not contain illegal or harmful information, impersonate or associate with institutions or public
            figures, and you must comply with the seven bottom lines of laws and regulations, socialist system, national
            interests, lawful rights and interests of citizens, public order, social morality, and information
            authenticity during the account registration process
          </p>
          <p class="mb-6" style="width: 910px">
            You agree and authorize us to initiate inquiries about the authenticity of your user identity, user credit
            record, and validity status of your user mobile phone number to reliable units such as the National Citizen
            Identity Number Query Service Center, telecom operators, and financial service institutions based on the
            information you provided, in order to provide better services to you and ensure the security of your
            account.
          </p>
          <p class="mb-6">
            (2) Update and Maintenance
          </p>
          <p class="mb-6" style="width: 910px">
            You should update your provided information in a timely manner. If the platform needs you to supplement any
            relevant information due to the requirements of national laws and regulations, departmental regulations, or
            regulatory agencies, and you cannot cooperate with the timely provision, the platform has the right to
            suspend or terminate part or all of the platform services to you, and you are responsible for any risks,
            liabilities, losses, expenses, etc. arising from this.
          </p>
          <p class="mb-6" style="width: 892px">
            If we fail to contact you based on the information you last updated, you fail to provide information in a
            timely manner according to our requirements, or the information you provided is obviously untrue, you will
            be liable for all losses and adverse consequences caused to yourself, others, and our platform.
          </p>
          <p class="mb-6">
            4.4 Account Security
          </p>
          <p class="mb-6">
            (1) Your account is set and kept by yourself.
          </p>
          <p class="mb-6" style="width: 892px">
            (2) We are not responsible for any loss or consequence caused by the disclosure of your account due to your
            active behavior or by the attack or fraud of others. You should seek relief from the infringing party
            through legal or administrative means.
          </p>
          <p class="mb-6">
            (3) Your account is for your personal use only and cannot be lent or shared with others. When your account
            is used without authorization, you should immediately notify our platform. Otherwise, unauthorized use will
            be deemed as your own behavior, and you will be responsible for all losses and consequences caused by this.
          </p>
          <p class="mb-6">
            (4) Except for our negligence, you are responsible for all actions taken under your account (including but
            not limited to online signing of various agreements, clicking agree/disagree to various rules and
            agreements, disclosure of information, uploading pictures, online design, posting information, purchasing or
            entrusting third parties to purchase goods or services, etc.).
          </p>
          <p class="mb-6" style="width: 892px">
            (5) If you find any unauthorized use of your account to log in to our platform or other situations that may
            cause your account to be stolen or lost, we recommend that you immediately notify us. You understand that
            our reasonable time is needed to take action in response to any of your requests, and the action taken by
            the platform in response to your request may not be able to avoid or prevent the formation or expansion of
            the consequences of the infringement. Except for our negligence, we are not responsible for the consequences
            caused by this.
          </p>
          <p class="mb-6">
            4.5 Account Cancellation
          </p>
          <p class="mb-6" style="width: 910px">
            (1) When you need to terminate the use of our platform services, you can apply for the cancellation of your
            account according to our process and page prompts. Please be aware of and agree to the following:
          </p>
          <p class="mb-6" style="width: 900px">
            • You can apply for the cancellation of your account through self-service or manual means.<br>
            • Your account should be in a normal state when you apply for cancellation, that is, your account
            information is up-to-date, complete, and correct, and your account is not subject to restrictive measures
            such as suspension or freezing by the competent authorities.<br>
            • In order to protect your and other users' legitimate interests, when you apply for account cancellation,
            we will conduct a risk review. Your account should not have any ongoing transactions or other outstanding
            rights and obligations, and there should be no other disputes that may arise from the cancellation. If your
            account has a balance, please withdraw all available funds corresponding to your account before canceling,
            or use them up through consumption or other means.
          </p>
          <p class="mb-6" style="width: 910px">
            (2) We have the right to cancel your account if any of the following circumstances occur:
          </p>
          <p class="mb-6" style="width: 910px">
            • If you have engaged in (including potentially engaged in) uploading illegal or non-compliant images on the
            platform, infringing (including potentially infringing) on the legitimate rights and interests of third
            parties, or other behaviors that violate the provisions of this agreement, platform rules, etc.<br>
            • If you use our platform services to engage in activities that infringe on the legitimate rights and
            interests of others or other serious illegal or breach of contract activities.<br>
            • If you have not logged in to the platform for 12 consecutive months.<br>
            • If your real-name authentication identity is invalid, no longer legally valid or cannot be effectively
            verified.<br>
            • If the account name you set contains illegal or harmful information or infringes or is suspected of
            infringing on the legitimate rights and interests of others; if you use someone else's account, publish
            prohibited information, engage in fraud, sell counterfeits, disrupt market order, or use improper means to
            make profits, etc.<br>
            • If you engage in behaviors that disrupt the normal trading order of the platform, such as maliciously
            processing orders and maliciously safeguarding rights for goods and services.<br>
            • If you use our platform for illegal trading, buying and selling, violating relevant laws, regulations, and
            policies of Hong Kong, China.<br>
            • If your account is canceled by us according to the platform rules due to your repeated violations of the
            relevant rules with serious consequences.<br>
            • If the platform suspends/terminates the provision of services to you based on the requirements of relevant
            national departments/government agencies.<br>
            • If the user account is canceled according to other provisions of this agreement.
          </p>
          <p class="mb-6" style="width: 910px">
            (3) After the user account is canceled, you will not be able to use our services, and the rights and
            obligations of both parties will terminate (except for the provisions that cannot be terminated or
            terminated according to their nature). At the same time, the following results may also occur:
          </p>
          <p class="mb-6" style="width: 910px">
            • All rights associated with the user account will be invalidated.<br>
            • If you have engaged in improper behavior such as illegal, breach of contract, and infringement before
            canceling your user account or are still performing a contract, you should still bear legal
            responsibility.<br>
            • Once the cancellation is successful, account records, account functions, etc. cannot be restored or
            provided.
          </p>
          <p class="mb-6" style="margin:16px 0">5. Platform Services and Regulations</p>
          <p class="mb-6">
            5.1 Platform Service Scope
          </p>
          <p class="mb-6" style="width: 910px">
            • Through our platform services, you can choose products and their templates for design, reach transaction
            intentions with manufacturers on the platform, and use other information and technical services.<br>
            • Our client for the website directly owned or operated by us includes but is not limited to all terminals
            such as PCs, tablets, and mobile phones.
          </p>
          <p class="mb-6">
            5.2 Product Selection and Design
          </p>
          <p class="mb-6">
            (1) You can choose platform products and their design templates for design.
          </p>
          <p class="mb-6">
            (2) You can use the platform's designer for product design. The product design function helps you create and
            optimize product visual design.
          </p>
          <p class="mb-6">
            (3) You can upload images for product design on the platform and establish your exclusive image library. The
            platform provides storage space for your image library.
          </p>
          <p class="mb-6">
            You understand and guarantee that the content you upload, publish, or transmit on our platform (including
            your account name and other information) does not contain the following content:
          </p>
          <p class="mb-6" style="width: 892px">
            • Oppose the basic principles established in the Constitution;<br>
            • Endanger national unity, sovereignty, and territorial integrity;<br>
            • Leaking state secrets, endangering national security, or damaging national honor and interests, damaging
            the portraits of Chinese and foreign leaders, state organs, law enforcement personnel, or revolutionary
            leaders;<br>
            • Inciting ethnic hatred, ethnic discrimination, undermining ethnic unity, or infringing on ethnic customs
            and habits;<br>
            • Distorting, vilifying, profaning, or denying the deeds and spirits of heroes and martyrs, insulting,
            slandering, or otherwise infringing on the names, portraits, reputations, and honors of heroes and
            martyrs;<br>
            • Infringing on the intellectual property rights of third parties (including but not limited to copyright,
            trademark rights, patent rights, privacy rights, or portrait rights), trade secrets, and other proprietary
            rights;<br>
            • Promoting cults and superstitions;<br>
            • Disrupting social order and undermining social stability;<br>
            • Inducing minors to commit crimes and promoting violence, pornography, gambling, and terrorist
            activities;<br>
            • Insulting or slandering others, infringing on the legitimate rights and interests of citizens' personal
            privacy, etc.;<br>
            • Endangering social public morals, damaging the excellent cultural traditions of the nation;<br>
            • Other contents prohibited by laws, administrative regulations, and national regulations, and other
            contents that are not suitable for publication on the platform according to the relevant platform
            agreements, terms, and rules.<br>
            If the content you upload, publish, or transmit contains information or content that violates laws and
            regulations or infringes on the legitimate rights and interests of any third party, you shall independently
            bear all adverse consequences and legal liabilities caused by the above and ensure that the platform,
            purchasing agents, and manufacturers are not held liable. If this causes adverse consequences to us, you
            shall be responsible for eliminating the impact and compensating us for all losses caused thereby, including
            but not limited to property damage compensation, reputation damage compensation, attorney fees,
            transportation fees, and other reasonable expenses incurred for safeguarding rights.
          </p>
          <p class="mb-6">
            (4) You acknowledge, declare, and guarantee that:
          </p>
          <p class="mb-6" style="width: 910px">
            • You have the corresponding and legal rights to the materials you upload to the platform (including but not
            limited to images uploaded to the image library and images designed online) or the information you publish
            on the platform;<br>
            • The images and other materials you upload to the platform or design online will not violate any laws or
            infringe on any third-party rights, including but not limited to any intellectual property rights, privacy
            rights, and portrait rights.<br>
            • The manufacturer, when using your images to produce or process customized products according to the
            customized content, shall not be responsible for any membership fees, residual compensation, fees, or usage
            fees arising from any collective bargaining agreements or other agreements.<br>
            • There are currently no lawsuits, claims, or other legal or administrative procedures that are unsettled or
            may be raised, which may directly or indirectly affect any of your customized materials or may in any way
            affect the right of the manufacturer to use the customized materials you provide.<br>
            • If your images in any way contain or incorporate any component, including but not limited to design
            elements, fonts, clip art, sub-pictures, vector graphics, or brush tools included in the design program,
            then uploading any such images to the platform means you have obtained a valid license that allows you to
            incorporate these elements into the image design you create, and allows you to grant a free license to the
            manufacturer designated by you for use within the scope of this agreement for the purposes specified in this
            agreement.
          </p>
          <p class="mb-6">
            5.3 Order Processing
          </p>
          <p class="mb-6" style="width: 910px">
            (1) When you place an order, please carefully confirm the information of the order, including but not
            limited to the name, price, quantity, model, specification, size, contact address, phone number, recipient's
            name, etc., and confirm the logistics carrier you have chosen. If there is any inconsistency between the
            information provided by the recipient and the information you provide to the platform, the recipient's
            actions shall be deemed to be your actions and representations, and you shall bear joint and several
            liability for the legal consequences of the recipient's actions and representations.
          </p>
          <p class="mb-6">
            (2) When you design and place an order on the platform, you must ensure that the images you upload to the
            platform meet the manufacturer's requirements for the product in terms of clarity, completeness, resolution,
            etc. If the images you provide do not meet the production process requirements, resulting in problems with
            the finished product, the platform and the manufacturer shall not be liable for any responsibility.
          </p>
          <p class="mb-6" style="width: 892px">
            (3) Due to legal and regulatory restrictions, our platform will review users' orders and arrange production
            and delivery after they have passed the review. If any content or information in the order (such as the
            text, images, LOGO customized by the user) violates the relevant laws, regulations, policies, this agreement
            or the platform rules of Hong Kong, China, we have the right to cancel the order or refuse
            service, and the user shall bear all losses caused thereby.
          </p>
          <p class="mb-6">
            (4) The information on the platform (including but not limited to price, product description, custom size,
            etc.) is accurate to the best of our efforts, but errors may occur due to personnel operations or system
            issues. In this case, we will confirm and modify the information correctly with you. You can cancel the
            order or produce according to the correct information. We apologize for any inconvenience caused.
          </p>
          <p class="mb-6" style="width: 910px">
            (5) Unless otherwise required by law, the parties agree as follows: the product and price information
            displayed on the platform is only the publication of transaction information and does not constitute an
            offer. When processing an order, you need to fill in the product quantity, recipient, contact information,
            shipping address, etc. The order information generated by the system is only the transaction offer you
            submitted to us. Only when we receive the order information and deliver the goods, the contract relationship
            between you and the platform for the ordered product is established. If you have multiple products in one
            order and we only send part of them, the transaction relationship between you and the platform is only
            established for that part of the product. You can log in to the platform's registered account at any time to
            check the status of your order.
          </p>
          <p class="mb-6" style="margin:16px 0">6. Logistics and After-sales Regulations</p>
          <p class="mb-6">
            6.1 The time limit for after-sales application is within 30 days from the date of order shipment.
          </p>
          <p class="mb-6">
            6.2 Scope of After-sales Service
          </p>
          <p class="mb-6">
            (1) Product quality problems of the ordered goods (including product quality and product shortages or
            omissions).
          </p>
          <p class="mb-6" style="width: 883px">
            <strong>Note：</strong>Relevant certificates (clear product problem pictures + clear express waybill +
            detailed problem description) need to be provided for initiating after-sales service. If the information
            provided for relevant certificates is missing, ambiguous, inconsistent with the application order, or
            fraudulent, the platform has the right to reject the return and refuse to handle the relevant after-sales
            service. The platform will submit the after-sales problems submitted by merchants to the responsible party
            for verification and confirmation. If there is a dispute between the responsible party and the user, the
            platform will make a comprehensive responsibility judgment based on the evidence provided by both parties,
            and the dispute time will not be included in the after-sales working day
          </p>
          <p class="mb-6">
            (2) After-sales caused by logistics problems of the order, the responsible party is the logistics carrier,
            and the corresponding logistics carrier shall bear the corresponding responsibility.
          </p>
          <p class="mb-6" style="width: 883px">
            <strong>Note：</strong>Due to force majeure factors that cause logistics problems (such as epidemics, wars,
            riots, natural disasters, flight restrictions, etc.), the platform has the right to terminate compensation
            according to the actual situation and inform it on the platform.
          </p>
          <p class="mb-6" style="width: 910px">
            (3) Special reminder: In special situations or due to special reasons, PRINTBELLE platform reserves the
            right not to provide after-sales service, including but not limited to the following situations:
          </p>
          <p class="mb-6" style="width: 910px">
            • The products sold on this platform are all customized products, and second sales are not possible. All
            products sold do not support returns or exchanges without reason;<br>
            • Poor printing effect due to user's own design problems or problems with the pictures used for design (such
            as blurred design elements, etc.);<br>
            • Normal color difference between the actual object and the webpage picture due to shooting light and
            different display resolutions;<br>
            • Product size and weight issues, reasonable errors that may exist as clearly stated in the product details;<br>
            • Logistics failure due to the wrong recipient information provided by the user;<br>
            • Delay caused by long statutory holidays;<br>
            • Delay in production and delivery caused by the system clearly indicating that the product is out of stock
            or the product is out of stock, but the user still places an order and pays;<br>
            • Cases that do not support after-sales application according to laws, regulations, or rules and
            regulations;<br>
            • Reasonable errors caused by normal production processes, such as seam errors, splicing errors, alignment
            errors, and other reasonable error ranges.
          </p>
          <p class="mb-6">
            6.3 After-sales Application Process
          </p>
          <p class="mb-6" style="width: 910px">
            (1) The user initiates an after-sales application, fills in the reasons for after-sales and the details of
            the problem, and provides the corresponding after-sales certificate as required.
          </p>
          <p class="mb-6" style="width: 885px">
            (2) After the platform receives the user's after-sales application, it will be processed within 2 working
            days (starting from the date the user submits the application, and correspondingly postponed if it falls on
            weekends, statutory holidays, etc.), and verify and confirm the user's submitted after-sales application
            problems and evidence certificates.
          </p>
          <p class="mb-6" style="width: 910px">
            (3) If there is no problem, the platform will approve the user's after-sales application based on the
            evidence provided. If there is a dispute over the evidence certificate, the platform will make a judgment
            based on the actual situation.
          </p>
          <p class="mb-6" style="width: 910px">
            (4) After the after-sales application is approved, the platform is expected to refund the amount to the
            user's account balance on this platform or resend the goods according to the user's request within 3-7
            working days.
          </p>
          <p class="mb-6" style="margin:16px 0">7. Privacy Protection</p>
          <p class="mb-6" style="width: 875px">
            7.1 We attach great importance to the protection of users' personal information (i.e., information that can
            identify users independently or in combination with other information). When you use the services provided
            by us, you agree that we collect, store, use, disclose, and protect your personal information in accordance
            with the privacy policy published on our platform. We hope to clearly introduce our processing of your
            personal information through the privacy policy. Therefore, we recommend that you read the privacy policy in
            full to help you better protect your privacy.
          </p>
          <p class="mb-6">
            7.2 You agree to unconditionally and free of charge grant the platform the right to use non-personal
            information provided or published by you, as well as information formed during the transaction process.
          </p>
          <p class="mb-6">
            7.3 You agree that the platform has the right to send notifications about our products and services,
            surveys, promotions, and sweepstakes to you through email, SMS, phone calls, announcements, and other forms.
          </p>
          <p class="mb-6" style="width: 892px">
            7.4 We may use your personal information to prevent, detect, investigate, and address fraud, security
            threats, illegal or prohibited activities, or violations of our agreements, policies, or rules with us or
            our affiliates, to protect your, other users', or third parties' legitimate rights and interests.
          </p>
          <p class="mb-6">
            7.5 Other purposes authorized by you.
          </p>
          <p class="mb-6" style="width: 855px">
            If you have any questions about this privacy policy, you can contact us through the contact information
            published on our platform. If you do not agree with any content of this privacy policy, you should
            immediately stop using our platform services. When you use any of the services provided by our platform, it
            means that you have agreed that we will legally use and protect your personal information in accordance with
            this privacy policy.
          </p>
          <p class="mb-6" style="margin:16px 0">8. User Code of Conduct</p>
          <p class="mb-6" style="width: 892px">
            8.1 During the use of the services on this platform, you declare and guarantee that you have the
            corresponding and legal rights to the materials you upload to the platform (including but not limited to
            images uploaded to the gallery, images designed online, etc.) or the information you post on the platform.
          </p>
          <p class="mb-6" style="width: 892px">
            8.2 You should use the online customization and transaction services provided by the platform in a lawful
            and compliant manner, and promise and guarantee that:
          </p>
          <p class="mb-6">
            (1) You will consciously abide by all applicable national and local laws and regulations;
          </p>
          <p class="mb-6" style="width: 892px">
            (2) All information and materials you provide related to the use of transaction services are true, legal,
            and accurate, and are not deceptive or misleading;
          </p>
          <p class="mb-6" style="width: 892px">
            (3) You will consciously abide by various laws and regulations related to national intellectual property and
            copyright, and will not copy or use copyrighted works without authorization;
          </p>
          <p class="mb-6" style="width: 892px">
            (4) You will not use any data on the platform for commercial purposes, including but not limited to using
            any materials displayed on the platform in any way such as copying or disseminating without the prior
            written consent of the platform;
          </p>
          <p class="mb-6">
            (5) You will not delete, conceal, or change any information displayed or contained on the platform that
            involves any patents, copyrights, trademarks, or other rights of the platform;
          </p>
          <p class="mb-6">
            (6) You will not engage in illegal and criminal activities such as illegal profit-making operations using
            the account registered on this platform;
          </p>
          <p class="mb-6">
            (7) You will not upload information that is threatening or damaging to others' reputation on the platform,
            and will not spread ideological content that is reactionary, unhealthy, or pornographic;
          </p>
          <p class="mb-6">
            (8) You will not transfer user accounts without authorization, nor steal or use others' user accounts.
          </p>
          <p class="mb-6" style="width: 892px">
            If you violate national laws and regulations or the above agreement content or engage in malicious behavior,
            the platform will not be able to guarantee your rights and interests, and has the right to impose
            corresponding penalties on you, including but not limited to restricting account functions, canceling
            accounts, etc. All losses shall be borne by users themselves; for suspected illegal and criminal activities
            of users, the platform will transfer them to judicial organs for processing.
          </p>
          <p class="mb-6" style="width: 885px">
            8.3 If the products you customize and purchase on the platform are goods for export, you promise to comply
            with all applicable import and export controls, customs and local government laws and regulations, trade
            restrictions, and economic sanctions related laws and regulations, and ensure that you are not subject to
            any trade restrictions, economic sanctions or other legal restrictions implemented by any country, region,
            or international organization. If you violate the above commitment, the platform may stop providing relevant
            services, actively execute the closure of related transaction orders, and carry out account cancellation and
            other operations.
          </p>
          <p class="mb-6">
            8.4 Violations
          </p>
          <p class="mb-6" style="width: 910px">
            You shall not engage in the following violations, including but not limited to: maliciously obtaining funds,
            bulk registration, bulk login, bulk signing, machine cheating, false transactions, disrupting the system,
            conducting network attacks, using mobile phone numbers of small operators, stealing or impersonating others'
            information, and other behaviors that are not in line with normal procurement practices or that harm the
            legitimate rights and interests of the platform, proxy buyers, logistics agents, manufacturers, other users
            or any third parties. Otherwise, the platform has the right to cancel your activity qualifications directly
            from the day when the above behavior is discovered, and suspend or limit all your platform services and
            other service activities (including but not limited to user account registration, image uploading, product
            design, order submission), and has the right to cancel relevant illegal transactions and rewards, and if
            necessary, will pursue your legal responsibilities.
          </p>
          <p class="mb-6" style="width: 885px">
            8.5 Our platform enjoys full intellectual property rights to platform-exclusive content, original content,
            and other exclusive or exclusive content obtained through authorization. Without the permission of the
            platform, users may not download, disseminate, copy or engage in other acts that infringe on the
            intellectual property rights of the platform. Otherwise, users will bear all relevant legal responsibilities
            themselves.
          </p>
          <p class="mb-6" style="margin:16px 0">9. Fees</p>
          <p class="mb-6" style="width: 892px">
            9.1 When using platform services, the platform has the right to charge you service fees.
            The platform has announced the fees for products, logistics and related services on relevant pages.
            You can choose the service items according to your needs and pay the service fees.
          </p>
          <p class="mb-6" style="width: 910px">
            9.2 Except for the charging services explicitly stated by the platform, other services are free of charge.
            The platform has the right to adjust the service fee charging standards according to changes in national
            laws and regulations and the platform's operational needs.
          </p>
          <p class="mb-6">
            9.3 All taxes payable and all hardware, software, communication, network services, and other expenses
            incurred by you when conducting transactions, obtaining paid services from the platform, or accessing
            platform servers or other third-party services shall be borne by you, and the platform shall not be
            responsible for them.
          </p>
          <p class="mb-6" style="margin:16px 0">10. Service Restrictions, Termination and Compensation</p>
          <p class="mb-6">
            10.1 The following situations are considered as a breach of contract by you:
          </p>
          <p class="mb-6">
            (1) Violation of relevant laws and regulations when using platform services;
          </p>
          <p class="mb-6">
            (2) Violation of the provisions of this agreement or other supplementary agreements of the platform.
          </p>
          <p class="mb-6" style="width: 910px">
            10.2 You understand and agree that the platform has the right to terminate your account, password (or any
            part thereof), or your use of platform services by notifying you in advance in accordance with legal
            requirements through website notifications, emails, mobile phone messages, etc.
          </p>
          <p class="mb-6" style="width: 855px">
            10.3 You understand and agree that if the platform closes your account based on the platform rules due to
            your breach of this agreement, even if your purchased membership service period has not expired, the
            platform still has the right to terminate the above service and will not refund any fees you have paid.
          </p>
          <p class="mb-6">
            10.4 In the event of the following situations, the platform has the right to restrict part or all of the
            permissions or functions of your account and cancel any outstanding orders related to the following
            situations, including but not limited to:
          </p>
          <p class="mb-6">
            (1) Repeatedly posting irrelevant advertising, insulting, or malicious negative evaluations in the
            consultation area;
          </p>
          <p class="mb-6" style="width: 892px">
            (2) Maliciously claiming compensation or filing complaints due to the platform's fault, insulting or
            attacking the platform or its staff for no reason;
          </p>
          <p class="mb-6" style="width: 910px">
            10.5 The platform may interrupt one or more services at any time based on strategic planning or market
            development. Except as required by law, the platform is not obligated to be responsible to any individual or
            third party. If you disagree with any provision of this agreement, have objections to any subsequent
            modifications to the agreement, or are dissatisfied with the platform's services, you may exercise the
            following rights:
          </p>
          <p class="mb-6">
            (1) Discontinue using any platform services;
          </p>
          <p class="mb-6" style="width: 892px">
            (2) Notify the platform to stop providing services to you. After the termination of the platform user
            service, your right to use the platform service immediately terminates. After termination, the platform will
            have no obligation to transmit or provide information materials generated by your use of the platform
            service to you or any third party.
          </p>
          <p class="mb-6">
            10.6 The platform has the right to directly terminate this agreement by canceling your user account and has
            the right to permanently freeze or cancel your account's permissions and usage rights on the platform in the
            following situations:
          </p>
          <p class="mb-6">
            (1) Your behavior, such as network attacks or posting a large number of advertisements, affects the normal
            operation of the platform or affects the platform's provision of services to other users;
          </p>
          <p class="mb-6" style="width: 892px">
            (2) You repeatedly maliciously place orders by taking advantage of the platform's and users' mistakes or
            vulnerabilities, seeking benefits;
          </p>
          <p class="mb-6" style="width: 892px">
            (3) You illegally obtain various virtual properties for the platform through plug-ins, network attacks, or
            other improper behavior (the platform has the right to freeze and liquidate the account without prior notice
            and reserve the right to pursue legal responsibility for relevant personnel);
          </p>
          <p class="mb-6" style="width: 892px">
            (4) The user information you provide (including but not limited to name, telephone, ID number, email
            address, address, etc.) is false, inaccurate, incomplete, or in violation of legal provisions;
          </p>
          <p class="mb-6">
            (5) You express and notify the platform that you do not accept any changes to this agreement or platform
            rules;
          </p>
          <p class="mb-6">
            (6) You have other behaviors that affect the normal operation of the platform or violate laws and
            regulations.
          </p>
          <p class="mb-6">
            10.7 You have the right to request the platform to cancel your account, and after the platform's review and
            approval, your account will be canceled, and the contractual relationship between you and the platform based
            on this agreement will be terminated.
          </p>
          <p class="mb-6">
            10.8 You understand and agree that:
          </p>
          <p class="mb-6">
            (1) The platform has the right to continue to retain any information you have on the platform after the
            termination of this agreement;
          </p>
          <p class="mb-6" style="width: 910px">
            (2) If you have engaged in illegal activities or violated this agreement or platform rules during the use of
            the service, the platform can still claim its rights against you according to this agreement;
          </p>
          <p class="mb-6" style="width: 855px">
            (3) After the termination of this agreement, for any transaction orders generated during the term of this
            agreement, the platform can notify the transaction counterpart and decide whether to terminate the
            transaction order based on the transaction counterpart's wishes. If the transaction counterpart requests to
            continue to perform the transaction, you shall continue to perform the obligations stipulated in this
            agreement and the transaction order, and bear any losses or additional costs incurred as a result;
          </p>
          <p class="mb-6" style="width: 892px">
            (4) After your account is terminated, except as explicitly required by law, the platform has no obligation
            to retain any electronic information in your original account or disclose any information to you or any
            third party. In addition, you understand and agree that the platform will not be responsible for terminating
            the provision of services to you or any third party.
          </p>
          <p class="mb-6">
            10.9 Compensation Liability:
          </p>
          <p class="mb-6" style="width: 892px">
            (1) If the platform suffers losses (including direct economic losses, loss of reputation and all indirect
            economic losses such as compensation, settlement payments, lawyer fees, litigation fees, etc.) due to your
            behavior, you shall compensate the platform for all losses.
          </p>
          <p class="mb-6" style="width: 892px">
            (2) If the platform is claimed by a third party due to your behavior, the platform may recover all losses
            from you after assuming responsibilityto the third party.
          </p>
          <p class="mb-6" style="margin:16px 0">11. Liability Limitations</p>
          <p class="mb-6">
            11.1 The platform shall assume basic guarantee obligations in accordance with legal requirements, but cannot
            be held responsible for the following damages caused to you due to force majeure or third-party reasons:
          </p>
          <p class="mb-6">
            (1) Damage caused by force majeure factors such as strikes, riots, fires, floods, storms, explosions, wars,
            government actions, judicial administrative orders, etc.;
          </p>
          <p class="mb-6">
            (2) Unauthorized use of your account or alteration of your data by third parties;
          </p>
          <p class="mb-6">
            (3) Damage caused by public service factors or third-party factors such as power supply failures and
            communication failures;
          </p>
          <p class="mb-6" style="width: 892px">
            (4) Damage caused by information network equipment maintenance, connection failure, computer, communication
            network, or other system failures;
          </p>
          <p class="mb-6">
            (5) Service interruption or delay caused by hacker attacks, computer viruses, website upgrades, etc.;
          </p>
          <p class="mb-6">
            (6) Expenses or losses incurred through the purchase or acquisition of goods, services, etc. through the
            platform;
          </p>
          <p class="mb-6">
            (7) Losses caused by misunderstanding of platform services on your part.
          </p>
          <p class="mb-6" style="width: 892px">
            11.2 Unless otherwise expressly stated in writing, all information, content, materials, products (including
            software) and services provided by the platform to you are provided on an "as-is" and "as-available" basis.
            The platform makes no representations or warranties, express or implied (Except as otherwise provided by the
            laws of Hong Kong, China), regarding the operation of the platform and the information,
            content, materials, products (including software) or services contained therein.
          </p>
          <p class="mb-6" style="width: 856px">
            11.3 You understand and agree that although the platform has established corresponding platform rules, it
            still cannot control or guarantee the authenticity, legality, and accuracy of product information, and
            cannot control or guarantee the quality, safety, or legality of the items involved in transactions, nor can
            it control or guarantee the ability of the parties involved in the transaction to perform their respective
            responsibilities. You should make careful judgments and take responsibility for yourself. If you find
            harmful information or behavior, please contact the platform in a timely manner. In the customer service
            dispute resolution service, the platform's customer service is not a professional and can only judge the
            evidence submitted by users based on their common sense. The platform does not guarantee that the dispute
            resolution decision will necessarily meet your expectations. Except for intentional or gross negligence as
            expressly provided by law, the platform shall not be liable for the dispute resolution decision.
          </p>
          <p class="mb-6" style="margin:16px 0">12. Applicable Law, Jurisdiction and Other Provisions</p>
          <p class="mb-6">
            12.1 This agreement shall be governed by the laws of Hong Kong, China for its conclusion, effectiveness,
            interpretation, revision, supplementation, termination, execution, and dispute resolution. In the absence of
            relevant legal provisions, commercial or industry practices shall apply.
          </p>
          <p class="mb-6" style="width: 892px">
            12.2 Any disputes arising from your use of the platform services and related to this agreement shall be
            resolved through consultation between you and the platform. If no agreement is reached, either party may
            bring a lawsuit to the people's court with jurisdiction over the place where the agreement was signed. The
            place of signing this agreement is HongKong, China.
          </p>
          <p class="mb-6" style="width: 863px">
            12.3 The platform's failure to exercise any right or provision under this agreement does not constitute a
            waiver of that right. If any provision of this agreement is held to be invalid or unenforceable, the
            remaining provisions of this agreement shall remain valid, binding, and enforceable.
          </p>
          <p class="mb-6" style="width: 863px">
            12.4 Unless otherwise agreed between the parties, you agree that the platform has the right to partially or
            fully transfer the rights and obligations under this agreement for operational purposes and will notify you
            in advance in a valid manner as stipulated in this agreement.
          </p>
          <p class="mb-6">
            12.5 WHEN YOU REGISTER AS A USER OF THE PLATFORM, YOU ARE DEEMED TO FULLY ACCEPT THE RIGHTS AND OBLIGATIONS
            STIPULATED IN THIS AGREEMENT.
          </p>
        </div>
      </div>
    </content>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../../components/Header.vue'
import Footer from '../../components/Footer.vue'
import {getNextMonthDate} from '@/utils/utils'

export default {
  name: 'LegalTerms',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      currentYear: ''
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    this.currentYear = getNextMonthDate(new Date().getFullYear(), new Date().getMonth() + 1)
  },
  created () {
  },
  methods: {},
}
</script>
<style scoped lang="less">

.content {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  background: #FFFFFF;

  .terms_box {
    width: 924px;
    margin-top: 173px;
    margin-bottom: 76px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      display: flex;
      align-items: center;
      font-weight: bold;
      font-size: 60px;
      color: #000000;
      line-height: 60px;
      font-family: IBM Plex Sans;
    }

    .time {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 18px;
      margin-top: 25px;
      color: #000000;
      font-family: IBM Plex Sans;
    }
  }

  .row_view {
    margin-top: 38px;

    .mb-6 {
      color: #000000;
      font-size: 16px;
      font-weight: 400;
      margin: 8px 0;

      i {
        font-family: IBM Plex Sans;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/legal/LegalTerms.vue